import { useAuthStore } from '@entities/auth/stores/useAuthStore';

import { type PostAuthResponse } from '@services/AuthService';

import { isAccount } from './isAccount';
import {
  LEGACY_BACKEND_ACCOUNT,
  loadAccountSettings,
  receiveAccount,
} from './loadAccountSettings';
import { useAccountStore } from './useAccountStore';

export const applyAuthResponse = (response: PostAuthResponse) => {
  const authStore = useAuthStore.getState();

  authStore.setUser(response.user);
  authStore.setReferrals(response.referrals);
  authStore.setSwipeStatus(response.swipe_status);
  authStore.setVerificationStatus(response.verification_status);

  const { account } = response;

  if (isAccount(account)) {
    receiveAccount(account);
    return;
  }

  const { status, isAutoRetrySpent, spendAutoRetry } =
    useAccountStore.getState();

  if (status === 'ready') return;

  if (account === undefined) {
    receiveAccount(LEGACY_BACKEND_ACCOUNT);
    return;
  }

  if (isAutoRetrySpent) return;

  spendAutoRetry();
  void loadAccountSettings();
};
